export const IMG = {
  hero: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85",
  kitchen: "https://images.unsplash.com/photo-1556911220-bff31c812dba?crop=entropy&cs=srgb&fm=jpg&q=85",
  bathroom: "https://images.unsplash.com/photo-1629079447777-1e605162dc8d?crop=entropy&cs=srgb&fm=jpg&q=85",
  endOfLease: "https://images.unsplash.com/photo-1630699144919-681cf308ae82?crop=entropy&cs=srgb&fm=jpg&q=85",
  childcare: "https://images.unsplash.com/photo-1770096679916-2cd9c720d400?crop=entropy&cs=srgb&fm=jpg&q=85",
  warehouse: "https://images.unsplash.com/photo-1772300704502-410f0fbd43bb?crop=entropy&cs=srgb&fm=jpg&q=85",
  commercial: "https://images.unsplash.com/photo-1774953037913-af0cf688491a?crop=entropy&cs=srgb&fm=jpg&q=85",
  living: "https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?crop=entropy&cs=srgb&fm=jpg&q=85",
  equipment: "https://images.unsplash.com/photo-1626379481874-3dc5678fa8ca?crop=entropy&cs=srgb&fm=jpg&q=85",
  team: "https://images.pexels.com/photos/6197108/pexels-photo-6197108.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portrait: "https://images.unsplash.com/photo-1732395805034-e0bf859665e5?crop=entropy&cs=srgb&fm=jpg&q=85",
  office: "https://images.unsplash.com/photo-1627905646269-7f034dcc5738?crop=entropy&cs=srgb&fm=jpg&q=85",
  medical: "https://images.unsplash.com/photo-1669101602124-f5b78895d91c?crop=entropy&cs=srgb&fm=jpg&q=85",
  interior: "https://images.unsplash.com/photo-1502005097973-6a7082348e28?crop=entropy&cs=srgb&fm=jpg&q=85",
  floor: "https://images.unsplash.com/photo-1669101602108-fa5ba89507ee?crop=entropy&cs=srgb&fm=jpg&q=85",
  beforeKitchen: "https://images.unsplash.com/photo-1570777758852-62d94955956a?crop=entropy&cs=srgb&fm=jpg&q=85",
  afterKitchen: "https://images.unsplash.com/photo-1610276099118-c929abaaa80a?crop=entropy&cs=srgb&fm=jpg&q=85",
  beforeBathroom: "https://images.unsplash.com/photo-1570555142359-665ec5d492dd?crop=entropy&cs=srgb&fm=jpg&q=85",
  afterBathroom: "https://images.unsplash.com/photo-1714399417136-d328f3ea14c7?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const isPlaceholder = (v) => !v || v.includes("[");

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/residential", label: "Residential" },
  { to: "/commercial", label: "Commercial" },
  { to: "/#why-us", label: "Why Us" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    id: "residential",
    name: "Residential Cleaning",
    desc: "Regular and one-off home cleaning — kitchens, bathrooms, living areas and everything in between.",
    image: IMG.living,
    link: "/residential",
    items: ["Regular House Cleaning", "One-Off House Cleaning", "Deep Cleaning", "Spring Cleaning", "Apartment Cleaning", "Kitchen Cleaning", "Bathroom Cleaning", "Bedroom Cleaning", "Living Area Cleaning", "Dusting", "Vacuuming", "Mopping", "Surface Cleaning", "Interior Cleaning", "Move-In Cleaning", "Move-Out Cleaning"],
  },
  {
    id: "end-of-lease",
    name: "End of Lease Cleaning",
    desc: "Thorough vacate cleans and property inspection preparation to present your rental at its best.",
    image: IMG.endOfLease,
    link: "/specialised",
    items: ["End of Lease Cleaning", "Rental Property Cleaning", "Property Inspection Preparation", "Kitchen Deep Cleaning", "Bathroom Deep Cleaning", "Interior Cleaning", "Final Presentation Cleaning"],
  },
  {
    id: "commercial",
    name: "Commercial Cleaning",
    desc: "Reliable workplace cleaning for offices, retail and commercial buildings — on your schedule.",
    image: IMG.office,
    link: "/commercial",
    items: ["Office Cleaning", "Corporate Cleaning", "Retail Cleaning", "Shop Cleaning", "Commercial Building Cleaning", "Reception Area Cleaning", "Meeting Room Cleaning", "Staff Kitchen Cleaning", "Common Area Cleaning", "Commercial Bathroom Cleaning", "Regular Workplace Cleaning"],
  },
  {
    id: "medical",
    name: "Medical & Healthcare Cleaning",
    desc: "Hygiene-focused cleaning with strict attention to high-touch surfaces and sanitisation.",
    image: IMG.medical,
    link: "/specialised",
    items: ["Medical Centre Cleaning", "Clinic Cleaning", "Dental Practice Cleaning", "Physiotherapy Clinic Cleaning", "Healthcare Facility Cleaning", "High-Touch Surface Cleaning", "Sanitisation", "Hygiene-Focused Cleaning"],
  },
  {
    id: "education",
    name: "Education & Childcare Cleaning",
    desc: "Careful, consistent cleaning for childcare centres, schools and learning environments.",
    image: IMG.childcare,
    link: "/specialised",
    items: ["Childcare Cleaning", "Early Learning Centre Cleaning", "School Cleaning", "Education Facility Cleaning", "Classroom Cleaning", "Common Area Cleaning", "Bathroom Cleaning", "High-Touch Surface Cleaning"],
  },
  {
    id: "industrial",
    name: "Industrial & Warehouse Cleaning",
    desc: "Heavy-duty cleaning for warehouses, factories, workshops and high-traffic industrial areas.",
    image: IMG.warehouse,
    link: "/specialised",
    items: ["Warehouse Cleaning", "Industrial Cleaning", "Factory Cleaning", "Workshop Cleaning", "Warehouse Floor Cleaning", "High-Traffic Area Cleaning", "Staff Facility Cleaning", "Industrial Common Areas"],
  },
  {
    id: "specialised",
    name: "Specialised Cleaning",
    desc: "Deep cleans, sanitisation, event and renovation cleaning — tailored to unusual requirements.",
    image: IMG.equipment,
    link: "/specialised",
    items: ["Deep Cleaning", "High-Touch Area Cleaning", "Sanitisation", "Post-Event Cleaning", "Pre-Event Cleaning", "Renovation Cleaning", "Property Presentation Cleaning", "Custom Cleaning Solutions"],
  },
];

export const WHY_POINTS = [
  { icon: "ShieldCheck", title: "Reliable & Professional", desc: "We take pride in providing dependable cleaning services with attention to detail." },
  { icon: "SlidersHorizontal", title: "Flexible Cleaning Options", desc: "Choose one-off, regular or customised cleaning services based on your needs." },
  { icon: "Building2", title: "Residential & Commercial", desc: "From homes and apartments to offices, clinics, warehouses and commercial facilities." },
  { icon: "BadgeCheck", title: "Quality-Focused", desc: "We focus on consistent cleaning standards and customer satisfaction." },
  { icon: "Wallet", title: "Affordable Options", desc: "Professional cleaning solutions designed to suit different budgets and requirements." },
  { icon: "HeartHandshake", title: "Customer-Focused Service", desc: "We listen to your requirements and tailor our service accordingly." },
  { icon: "Sparkles", title: "Attention to Detail", desc: "We don't simply clean visible areas — we focus on the details that make a space feel genuinely clean." },
  { icon: "CalendarClock", title: "Flexible Scheduling", desc: "Cleaning at suitable times based on your requirements and availability." },
];

export const BUDGET_SEGMENTS = [
  { tag: "Affordable", title: "Affordable Cleaning Solutions", desc: "Professional cleaning without unnecessary extras — targeted, high-impact results that respect your budget." },
  { tag: "Regular", title: "Regular Home Cleaning", desc: "Spend less time cleaning and more time enjoying your home with a consistent cleaning routine." },
  { tag: "Premium", title: "Premium Cleaning Services", desc: "Detailed, high-quality cleaning for customers who expect an exceptional standard of finish." },
  { tag: "Business", title: "Reliable Commercial Cleaning", desc: "Professional cleaning solutions designed around your workplace and operating requirements." },
];

export const STEPS = [
  { num: "01", title: "Tell Us What You Need", desc: "Submit the enquiry form or contact our team with your suburb and property details." },
  { num: "02", title: "Get Your Quote", desc: "We'll discuss your cleaning requirements and provide a suitable quote." },
  { num: "03", title: "Schedule Your Service", desc: "Choose a suitable date and time based on availability." },
  { num: "04", title: "Enjoy a Cleaner Space", desc: "Our team completes the cleaning service with care and attention to detail." },
];

export const PROPERTY_TYPES = [
  "Residential", "Apartment", "House", "Office", "Retail", "Medical Facility",
  "Warehouse", "Industrial", "Childcare / Education", "End of Lease", "Other",
];

export const FREQUENCIES = [
  "One-off", "Weekly", "Fortnightly", "Monthly", "Regular Commercial", "Custom",
];

export const SERVICE_OPTIONS = [
  "Regular House Cleaning", "One-Off / Deep Cleaning", "End of Lease Cleaning",
  "Office / Commercial Cleaning", "Medical & Healthcare Cleaning",
  "Education & Childcare Cleaning", "Industrial & Warehouse Cleaning",
  "Specialised Cleaning", "Other / Not Sure",
];

export const MARQUEE_ITEMS = [
  "Perth CBD", "Northern Suburbs", "Southern Suburbs", "Eastern Suburbs", "Western Suburbs",
  "Residential Cleaning", "Commercial Cleaning", "End of Lease", "Medical Facilities",
  "Warehouses", "Childcare Centres", "Get a Free Quote",
];
